<template>
  <div class="row">
    <div class="col-md-12">
      <modal :show.sync="ModalProduct">
        <template slot="header">
          <h1 class="modal-title">Crear Producto</h1>
        </template>
        <div>
          <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="create">
              <div class="row">

                <div class="col-12 text-left field-content-mobile radio-mobile radio-default-acre">
                  <label class="text-info-product">Tipo de producto que se va crear: </label>
                  <PrettyRadio v-model="SelectProductType" :value="false" class="p-default p-round" name="radio1">
                    Simple
                  </PrettyRadio>
                  <PrettyRadio v-model="SelectProductType" :value="true" class="p-default p-round" name="radio1">
                    Variable
                  </PrettyRadio>

                </div>
                <span class="text-info-product">Encabezado del producto</span>
                <div class="col-12 row field-content-mobile">
                  <div class="col-3 field-mobile">
                    <label for="namecre">Nombre producto</label>
                    <ValidationProvider name="product.name" rules="required"
                                        v-slot="{ errors }">
                      <input
                          id="namecre"
                          v-model="product.name"
                          type="text"
                          class="form-control"
                          placeholder="Nombre"
                      >
                      <p class="error-acre">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                  <div class="col-3 field-mobile">
                    <label class="typo__label">Categoria</label>
                    <multiselect
                        placeholder="Busque o agregue categoria"
                        tag-placeholder="Agregar categoria"
                        v-model="product.Category"
                        :options="Category"
                        :searchable="true"
                        track-by="category_id"
                        label="category"
                        :multiple="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :taggable="true" @tag="addTag">

                    </multiselect>
                  </div>
                  <!-- <div class="col-2">
                       <label class="typo__label">Tipo de producto</label>
                       <multiselect
                               v-model="product.ProductType"
                               :options="ProductType"
                               :searchable="false"
                               track-by="product_type_id"
                               label="type_name"
                               :close-on-select="false"
                               :show-labels="false"
                               placeholder="Seleccione una opción"></multiselect>
                   </div> -->
                  <div class="col-3 field-mobile">
                    <label class="typo__label">Unidad de medida</label>
                    <multiselect v-model="product.unit" tag-placeholder="Agregar una nueva"
                                 placeholder="Seleccionar Unidad" label="unit_name"
                                 track-by="unit_type_id" :options="UnitType"
                                 :multiple="true"></multiselect>
                  </div>
                  <div class="col-3 field-mobile">
                    <label for="taxcre">Iva</label>
                    <ValidationProvider name="product.tax" rules="required"
                                        v-slot="{ errors }">
                      <input
                          id="taxcre"
                          v-model="product.tax"
                          type="number"
                          class="form-control"
                      >
                      <p class="error-acre">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                </div>
                <span class="text-info-product">Crear SKU del producto</span>
                <div class=" col-12 row field-content-mobile">
                  <div class="col-4 field-mobile">
                    <label for="skucre">Codigo SKU</label>
                    <input
                        id="skucre"
                        v-model="product_sku.sku"
                        type="text"
                        class="form-control"
                        placeholder="Codigo SKU"
                    >
                    <p class="error-acre">{{ valsku }}</p>
                  </div>

                  <div v-show="SelectProductType" class="col-4 field-mobile">
                    <label for="nameskucre">Nombre</label>
                    <input
                        id="nameskucre"
                        v-model="product_sku.name"
                        type="text"
                        class="form-control"
                        placeholder="Nombre"
                    >
                  </div>
                  <div class="col-4 field-mobile">
                    <label for="descryptioncre">Descripción</label>
                    <input
                        id="descryptioncre"
                        v-model="product_sku.description"
                        type="text"
                        class="form-control"
                        placeholder="Descripción"
                    >
                  </div>
                  <div class="col-4 field-mobile">
                    <label for="stockcre">Stock Kilos</label>
                    <input
                        id="stockcre"
                        v-model="product_sku.stock_quantity"
                        type="number"
                        class="form-control"
                        placeholder="Stock"
                    >
                  </div>
                  <div class="col-4 field-mobile" v-if="input_uni">
                    <label for="stockcreUni">Equivalencia de Unidad a Kilo</label>
                    <input
                        id="stockcreUni"
                        v-model="product_sku.unit_stock_quantity"
                        type="number"
                        class="form-control"
                        placeholder="Stock"
                    >
                  </div>
                  <div class="col-4 field-mobile" v-if="input_price">
                    <label for="pricecre">Precio Kilo</label>
                    <input
                        id="pricecre"
                        v-model="product_sku.price"
                        type="number"
                        class="form-control"
                        placeholder="Precio"
                    >
                  </div>
                  <div class="col-4 field-mobile" v-if="input_uni">
                    <label for="pricegrcre">Precio Unidad</label>
                    <input
                        id="pricegrcre"
                        v-model="product_sku.unit_price"
                        type="number"
                        class="form-control"
                        placeholder="Peso"
                    >
                  </div>

                  <!--<div class="col-4">
                      <label for="onsalecre"> Onsale</label>
                      <br>
                      <span>Sin Descuento</span>
                      <label class="custom-toggle">
                          <input type="checkbox"
                                 id="onsalecre"
                                 v-model="product_sku.onsale">
                          <span class="custom-toggle-slider rounded-circle"></span>
                      </label> <span>Descuento</span>
                  </div>-->

                  <div class="col-4 field-mobile radio-default-acre radio-mobile">
                    <label class="text-info-product">Estado SKU: </label>
                    <PrettyRadio v-model="product_sku.state_id.state_id" class="p-default p-round" name="radio2"
                                 :value="true">Activo
                    </PrettyRadio>
                    <PrettyRadio v-model="product_sku.state_id.state_id" class="p-default p-round r-inactive"
                                 name="radio2" :value="false">Inactivo
                    </PrettyRadio>

                  </div>

                  <div class="col-12 text-left form-group field-mobile input-file">
                    <label for="filecre">Imagen de producto</label>
                    <br>
                    <input placeholder="Seleccionar imagenes" type="file"
                           id="filecre" ref="file"
                           v-on:change="onChangeFileUpload()"/>
                    <img v-if="img_preview" style="width: 33px" :src="img_preview"/>
                  </div>

                  <div v-show="SelectProductType" class="col-12 field-mobile">
                    <base-button :disabled="btn_addsku" size="sm" outline type="default"
                                 @click="addsku">Agregar SKU
                    </base-button>
                  </div>
                </div>
              </div>
              <div v-show="SelectProductType" class="row">
                <span class="text-info-product">Detalle SKU</span>
                <div class="table-responsive table-flush">
                  <table class="table align-items-start table-dark">
                    <thead>
                    <th></th>
                    <th>Nombre variante</th>
                    <th>Codigo SKU</th>
                    <th>Descripcion</th>
                    <th>Precio KL</th>
                    <th>Precio Unidad</th>
                    <th>Stock</th>
                    <th></th>
                    </thead>
                    <tbody v-if="data_product_sku.length > 0 ">
                    <tr v-for="(row, index) in data_product_sku" :key="index">
                      <td>
                        <img v-if="row.img" :src="row.img"
                             alt=""
                             style="width: 33px">
                      </td>
                      <th scope="row">
                        <div class="media align-items-center">
                          <div class="media-body">
                            <span class="name mb-0 text-sm">{{ row.name }}</span>
                          </div>
                        </div>
                      </th>
                      <td>
                        {{ row.sku }}
                      </td>
                      <td>
                        {{ row.description }}
                      </td>
                      <td class="budget">
                        {{ row.price }}
                      </td>
                      <td class="budget">
                        {{ row.unit_price }}
                      </td>
                      <td class="budget">
                        {{ row.stock_quantity }}
                      </td>
                      <td>
                        <base-button size="sm" type="danger" @click="deletesku(index)"
                                     icon="ni ni-fat-remove"></base-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <base-alert class="text-left" v-show="error" type="warning">
                <strong class="error-acre">{{ error }}</strong>
              </base-alert>
              <base-button v-if="btn_create" @click="create" :disabled="invalid" class="btn-save btn_submit">
                Guardar
              </base-button>
            </form>
          </ValidationObserver>
        </div>
        <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                       label="Guardando"></base-progress>
        <template slot="footer">

        </template>

      </modal>
    </div>
  </div>
</template>

<script>

import {bus} from "./bus-product";
import {extend, ValidationProvider} from 'vee-validate'
import {ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import {product_service} from '../../services/product/ProductService'
import _ from "lodash";
import swal from 'sweetalert';
import PrettyRadio from 'pretty-checkbox-vue/radio';

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})
export default {
  name: "CreateProduct",
  components: {ValidationProvider, ValidationObserver, PrettyRadio},
  data() {
    return {
      alertmss: 'success',
      msscategory: '',
      progress: 0,
      img_preview: null,
      btn_create: true,
      error: '',
      valsku: '',
      products: {},
      btn_addsku: true,
      file: '',
      input_uni: false,
      input_price: true,
      ModalProduct: false,
      data_product_sku: [],
      file_sku: [],
      data_product_inventory: [],
      Category: [],
      ProductType: [],
      UnitType: [],
      SelectProductType: false,
      product: {
        name: '',
        Category: {},
        ProductType: {},
        tax: 0,
        UnitType: {
          "unit_type_id": 1,
          "unit_name": "Kilo",
          "shotname": "KL"
        },
        unit: [{
          "unit_type_id": 1,
          "unit_name": "Kilo",
          "shotname": "KL"
        }]
      },
      product_sku: {
        sku: '',
        price: 0,
        unit_price: 0,
        description: '',
        onsale: 0,
        name: '',
        deletedAt: null,
        img: null,
        product_id: {
          product_id: 0
        },
        state_id: {
          state_id: true
        },
        stock_quantity: 0,
        unit_stock_quantity: 0
      },
      product_inventory: {
        stock_quantity: '',
        unit_stock_quantity: '',
        productskuSkuProductId: ''
      }

    }
  },
  watch: {
    'product.unit': function () {

      const w = _.find(this.product.unit, function (item) {
        if (item.shotname === 'Uni') {
          return true
        } else {
          return false
        }
      })
      const k = _.find(this.product.unit, function (item) {
        if (item.shotname === 'KL' || item.shotname === 'GR') {
          return true
        } else {
          return false
        }
      })
      if (w === false) {
        this.input_uni = false
        this.product_sku.unit_price = 0
      } else {
        this.input_uni = w
      }
      if (k === false) {
        this.input_price = false
        this.product_sku.price = 0
      } else {
        this.input_price = k
      }
    },
    'product_sku.sku': function () {
      const p = _.filter(this.products, (c) => {
        if (c.sku === this.product_sku.sku) {
          return c
        }
      })
      if (p.length === 0) {
        if (this.product_sku.sku === '') {
          this.btn_addsku = true
          this.valsku = 'El SKU no puede estar vacio'
        } else {
          this.btn_addsku = false
          this.valsku = ''
        }
      } else {
        this.valsku = 'El SKU ya existe'
        this.btn_addsku = true
      }

    }
  },
  methods: {
    addTag(newTag) {
      let data = {
        category: newTag
      }
      product_service.CreateCategory(data)

    },
    create() {
      if (this.SelectProductType === false) {
        if (this.product_sku.sku != '') {
          this.createsimple()
          this.progress = 20
        } else {
          this.error = 'Debe Ingresar un SKU'
        }

      }
      if (this.SelectProductType === true) {
        if (this.data_product_sku.length > 0) {
          this.createvariable()
          this.progress = 20
        } else {
          this.error = 'Debe Ingresar una variación'
        }

      }
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files;
      this.img_preview = URL.createObjectURL(this.file[0]);
    },
    ShowProduct() {
      this.ModalProduct = !this.ModalProduct
      this.cleandata()
    },
    createvariable() {
      this.btn_create = false

      this.product.ProductType = {
        product_type_id: 2
      }
      this.product.unit = JSON.stringify(this.product.unit)
      product_service.CreateProduct(this.product)
    },
    createsimple() {
      this.btn_create = false
      /*   if (this.product_sku.onsale === true) {
             this.product_sku.onsale = 1
         } else {
             this.product_sku.onsale = 0
         }*/
      this.product_sku.onsale = 0
      if (this.product_sku.state_id.state_id === true || this.product_sku.state_id.state_id === 1) {
        this.product_sku.state_id.state_id = 1
      } else {
        this.product_sku.state_id.state_id = 2
      }
      this.product.ProductType = {
        product_type_id: 1
      }
      this.data_product_sku.push(this.product_sku)
      this.file_sku.push({'sku': this.product_sku.sku, 'image': this.file})
      this.product.unit = JSON.stringify(this.product.unit)
      product_service.CreateProduct(this.product)

    },
    addsku() {
      let img = null
      if (this.file[0]) {
        img = URL.createObjectURL(this.file[0])
      }
      /*   if (this.product_sku.onsale === true) {
            this.product_sku.onsale = 1
        } else {
            this.product_sku.onsale = 0
        }*/
      this.product_sku.onsale = 0
      this.product_sku.img = img
      if (this.product_sku.state_id.state_id === true) {
        this.product_sku.state_id.state_id = 1
      } else {
        this.product_sku.state_id.state_id = 2
      }


      this.data_product_sku.push(this.product_sku)
      this.file_sku.push({'sku': this.product_sku.sku, 'image': this.file})
      this.cleandata()

    },
    deletesku(x) {

      this.data_product_sku.splice(x, 1)
    },
    cleandata() {
      this.product_sku = {
        sku: '',
        price: 0,
        unit_price: 0,
        description: '',
        onsale: 0,
        name: '',
        product_id: {
          product_id: 0
        },
        state_id: {
          state_id: true
        },
        stock_quantity: 0,
        unit_stock_quantity: 0
      }
      this.product_inventory = {
        stock_quantity: '',
        unit_stock_quantity: '',
        productskuSkuProductId: ''
      }
      this.error = ''
      this.file = ''
      const input = this.$refs.file
      input.type = 'text'
      input.type = 'file'
      this.progress = 0
      this.btn_create = true
      this.msscategory = ''
    },
    cleandatafull() {
      this.product = {
        name: '',
        Category: {},
        ProductType: {},
        UnitType: {
          "unit_type_id": 2,
          "unit_name": "Gramo",
          "shotname": "GR"
        },
        unit: [{
          "unit_type_id": 2,
          "unit_name": "Gramo",
          "shotname": "GR"
        }]
      }
      this.progress = 0
      this.data_product_sku = []
      this.data_product_inventory = []
      this.file_sku = []
      this.btn_create = true
      this.cleandata()
      this.ShowProduct()
      product_service.GetAllProductSku()
      product_service.GetAllCategory()
      product_service.GetAllProductType()
      product_service.GetAllUnitType()
      product_service.GetAllProduct()
    }

  },
  created() {
    bus.$on('ShowProduct', () => {
      this.ShowProduct()
    })
    bus.$on('GetAllCategory', (response) => {
      this.Category = response
    })
    bus.$on('GetAllProductType', (response) => {
      this.ProductType = response
    })
    bus.$on('GetAllUnitType', (response) => {
      this.UnitType = response
    })
    bus.$on('ResponseCreateProduct', (response) => {
      if (response.statusText === 'Created') {
        if (this.data_product_sku.length > 0) {
          const data = _.map(this.data_product_sku, items => {
            if (items.product_id) {
              items.product_id.product_id = response.data.product_id
            }
            return items;
          });
          product_service.CreateProductSku(data)
          this.progress = 40
        } else {
          this.cleandatafull()
          swal({
            icon: "success",
            text: "Se creado un producto sin SKU, para agregar SKU vaya a la edicion del producto editelo",
            button: "Aceptar"
          })
        }
      } else {
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Se Registro El Producto Correctamente",
          button: "Aceptar"
        })
      }
    })
    bus.$on('ResponseCreateProductSku', (response) => {
      if (response.statusText === 'Created') {
        this.progress = 60
        //console.log("response",response)
        if (response.data.length > 0) {
          const arr1 = this.data_product_sku
          const arr = response.data
          //crea inventario por SKU
          for (const dat in arr1) {
            for (const prop in arr) {
              if (arr1[dat].sku === arr[prop].sku) {
                console.log(arr1[dat])
                this.data_product_inventory.push({
                  "stock_quantity": arr1[dat].stock_quantity,
                  "unit_stock_quantity": arr1[dat].unit_stock_quantity,
                  "Productsku": {"sku_product_id": +arr[prop].sku_product_id}
                })
              }
            }
          }
          this.progress = 80
          product_service.CreateProductInventory(this.data_product_inventory)
          //fin crea SKU
          //Crea galeria por SKU
          const arr_img = this.file_sku
          for (const arrimg in arr_img) {
            product_service.CreateProductSkuGalery(arr_img[arrimg].sku, arr_img[arrimg].image)
          }
          //frin crea galeria
          this.progress = 100
        } else {
          this.cleandatafull()
          swal({
            icon: "success",
            text: "Se Ha creado Un Producto Con Exito",
            button: "Aceptar"
          })
        }
      } else {
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Se Registro El SKU Del Producto Correctamente, !Edita el producto¡",
          button: "Aceptar"
        })
      }
    })
    bus.$on('ResponseCreateProductInventory', (response) => {
      if (response.statusText === 'Created') {
        this.cleandatafull()
        swal({
          icon: "success",
          text: "Se Ha creado Un Producto Con Exito",
          button: "Aceptar"
        })
      } else {
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Fue Posible Asignar Stock Al Producto, !Edita el producto¡",
          button: "Aceptar"
        })
      }
    })
    bus.$on('ResponseCreateProductSkuGalery', (response) => {
      console.log(response)
    })
    bus.$on('GetAllProductSku', (response) => {
      this.products = _.filter(response, (c) => {
        if (c.deletedAt === null) {
          return c
        }
      })
    })
    bus.$on('ResponseCreateCategory', (response) => {
      product_service.GetAllCategory()
      if (response.statusText === 'Created') {
        this.product.Category = response.data
        this.msscategory = 'La categoria ' + response.data.category + ' se creo correctamenta'
      } else {
        this.alertmss = 'danger'
        this.msscategory = 'La categoria ' + response.data.category + ' no fue posible crearla. !Intenta nuevamente¡'
      }
      setTimeout(() => this.msscategory = '', 4000);
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .radio-default-acre {
    margin-bottom: 2em;
  }
}
</style>
